































import { Component, Vue, Ref } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { ActionsPayload, ActionsKeys } from '@/store/types';
import AzureAuth from '@/plugins/AzureAuth';

@Component({})
export default class LoginForm extends Vue {
  @Ref('loginForm') loginForm!: Vue;
  @Action(ActionsKeys.SET_CURRENT_USER) setCurrentUser!: (payload: ActionsPayload['SET_CURRENT_USER']) => void;

  validLoginForm = true;
  loggedIn = false;
  error = false;

  registerData = {
    pin: '',
  };

  registerDataValidations = {
    pin: [(v: string) => !!v || 'Pin is required'],
  };

  mounted() {
    const pin = this.$route.query.pin;
    if (pin && !Array.isArray(pin)) {
      this.registerData.pin = atob(pin);
    }
    localStorage.removeItem('pin');
  }

  async submitRegister() {
    /* eslint-disable @typescript-eslint/camelcase */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((this.loginForm as any).validate()) {
      try {
        const res = await fetch(`${process.env.VUE_APP_API_URL}/auth/guest_login_aad`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token: await AzureAuth.getToken(),
            pin: this.registerData.pin,
          }),
        });
        if (res.status === 200) {
          this.loggedIn = true;
          const { guest: user, token: jwt } = await res.json();
          this.setCurrentUser({
            user: { ...user },
            jwt,
          });
        } else {
          this.error = true;
        }
      } catch (e) {
        console.warn(e);
      }
    }
    /* eslint-enable @typescript-eslint/camelcase */
  }
}
